import axiosInstance from "./axios";

export const fetchAssignedFollowUpsRequest = async () =>
  axiosInstance
    .get("follow-up/fetch-assigned-follow-ups/")
    .then((response) => response.data);
